import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=60b8ffbf&scoped=true"
import script from "./addressList.vue?vue&type=script&lang=js"
export * from "./addressList.vue?vue&type=script&lang=js"
import style0 from "./addressList.vue?vue&type=style&index=0&id=60b8ffbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8ffbf",
  null
  
)

export default component.exports